if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.disabled || this.submitButton.getAttribute('aria-disabled') === 'true' ||
            this.variantIdInput.disabled || !this.variantIdInput.value ||
            this.closest('product-info')?.variantRequestPending) return;

        this.handleErrorMessage();
        this.addRecovery?.remove();
        this.addRecovery = null;
        this.error = false;

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.showAddError(response.description || response.message);
              if (String(this.variantIdInput.value) !== String(formData.get('id')) ||
                  this.closest('product-info')?.variantRequestPending) return;

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    try {
                      CartPerformance.measure("add:paint-updated-sections", () => {
                        this.cart.renderContents(response);
                      });
                    } catch (error) {
                      console.error(error);
                      window.location.assign(window.routes.cart_url);
                    }
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
            this.showRecoveryError('addUnconfirmed');
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      showAddError(message) {
        this.addRecovery?.remove();
        const wrapper = document.createElement('div');
        wrapper.className = 'koyo-purchase-unconfirmed';
        wrapper.setAttribute('role', 'alert');
        const text = document.createElement('p');
        text.textContent = message;
        wrapper.append(text);
        this.prepend(wrapper);
        this.addRecovery = wrapper;
        return wrapper;
      }

      showRecoveryError(kind, retry) {
        const strings = window.koyoPurchaseRecovery;
        let wrapper;
        if (retry) {
          this.handleErrorMessage(strings[kind], true);
          wrapper = this.errorMessageWrapper;
        } else {
          wrapper = this.showAddError(strings[kind]);
        }
        if (!wrapper) return;
        const actions = document.createElement('div');
        actions.className = 'koyo-purchase-recovery';
        const action = document.createElement(retry ? 'button' : 'a');
        action.className = 'button button--secondary';
        if (retry) {
          action.type = 'button';
          action.textContent = strings.retryOptions;
          action.addEventListener('click', retry, { once: true });
        } else {
          action.href = window.routes.cart_url;
          action.textContent = strings.viewCart;
        }
        actions.append(action);
        wrapper.append(actions);
        if (retry) this.recoveryActions = actions;
      }

      handleErrorMessage(errorMessage = false, force = false) {
        this.recoveryActions?.remove();
        this.recoveryActions = null;
        if (this.hideErrors && !force && errorMessage) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
